import { FILTER_KEYWORDS } from "../../consts";

const { SUBMISSION_TIME, FIRST_SEEN, LAST_SEEN } = FILTER_KEYWORDS;

export const LOCAL_TIME_TYPES = [
  {
    label: "Submission Time (local only)",
    title: "Submission Time",
    value: SUBMISSION_TIME
  },
  {
    label: "Last Seen (local only)",
    title: "Last Seen",
    value: LAST_SEEN
  },
  {
    label: "First Seen",
    title: "First Seen",
    value: FIRST_SEEN
  }
];

export const CLOUD_TIME_TYPES = [
  {
    label: "First Seen",
    title: "First Seen",
    value: FIRST_SEEN
  }
];

export const NETWORK_TIME_TYPES = [
  {
    label: "Submission Time (local only)",
    title: "Submission Time",
    value: SUBMISSION_TIME
  },
  {
    label: "First Seen",
    title: "First Seen",
    value: FIRST_SEEN
  },
  {
    label: "Last Seen",
    title: "Last Seen",
    value: LAST_SEEN
  }
];

export const DROPDOWN_STYLE = {
  button: {
    minWidth: "145px"
  },
  menu: {
    minWidth: "145px"
  }
};

export const enum SAMPLE_ORIGINS {
  TOP_CONTAINER = "top_container",
  URL_ANALYSIS = "url_analysis",
  EXTRACTED_FILES = "extracted_files",
  DROPPED_FILES = "dropped_files"
}

export const SAMPLE_ORIGIN_ITEMS = [
  {
    label: "Top Level Container",
    value: SAMPLE_ORIGINS.TOP_CONTAINER
  },
  {
    label: "URL Payload",
    value: SAMPLE_ORIGINS.URL_ANALYSIS
  },
  {
    label: "Extracted Files",
    value: SAMPLE_ORIGINS.EXTRACTED_FILES
  },
  {
    label: "Dropped Files",
    value: SAMPLE_ORIGINS.DROPPED_FILES
  }
];
